import { AppConstants } from '../constants';

let socket = null;
let pingInterval = null;
let reconnectTimeout = null;
let isManualClose = false;
let lastMessageObj = null;
let messageHandler = null; // ✅ handler lưu ngoài để dùng lại khi reconnect

export const initSocket = () => {
    return new Promise(resolve => {
        isManualClose = false;

        socket = new WebSocket(AppConstants.socketHost);

        socket.sendMessage = function (messageObj) {
            lastMessageObj = messageObj;
            this.send(JSON.stringify(messageObj));
        };

        socket.onmessage = function ({ data }) {
            let response = null;
            try {
                response = JSON.parse(data);
            } catch (error) {
                console.log("JSON parse error:", error);
            }

            // ✅ gọi handler lưu ngoài
            messageHandler && messageHandler(response);
        };

        socket.onopen = () => {
            console.log("✅ Socket connected");

            // ✅ gán lại handler sau khi connect
            socket.onReceiveMessage = messageHandler;

            startPing();
            resolve(socket);

            if (lastMessageObj) {
                socket.sendMessage(lastMessageObj);
            }
        };

        socket.onclose = () => {
            console.warn("⚠️ Socket disconnected");
            stopPing();

            if (!isManualClose) {
                scheduleReconnect();
            }
        };

        socket.onerror = (err) => {
            console.error("❌ Socket error:", err);
        };
    });
};

// ✅ hàm để set listener từ component khác
export const setOnReceiveMessage = (fn) => {
    messageHandler = fn;
    if (socket) {
        socket.onReceiveMessage = fn;
    }
};

const startPing = () => {
    stopPing();

    pingInterval = setInterval(() => {
        if (socket?.readyState === WebSocket.OPEN && lastMessageObj) {
            socket.sendMessage(lastMessageObj);
        }
    }, 10000);
};

const stopPing = () => {
    if (pingInterval) {
        clearInterval(pingInterval);
        pingInterval = null;
    }
};

const scheduleReconnect = () => {
    if (reconnectTimeout) return;

    reconnectTimeout = setTimeout(() => {
        reconnectTimeout = null;
        console.log("🔁 Reconnecting socket...");
        initSocket().then(newSocket => {
            socket = newSocket;

            // ✅ gán lại handler khi socket mới được tạo
            if (messageHandler) {
                socket.onReceiveMessage = messageHandler;
            }
        });
    }, 3000);
};

// Khi người dùng quay lại tab
document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
        console.log("📱 Tab is active again");

        if (!socket || socket.readyState !== WebSocket.OPEN) {
            initSocket().then(newSocket => {
                socket = newSocket;

                // ✅ gán lại handler
                if (messageHandler) {
                    socket.onReceiveMessage = messageHandler;
                }
            });
        }
    }
});

export const closeSocket = () => {
    isManualClose = true;
    stopPing();
    socket?.close();
};
